import { BarChartRendererComponent } from "@shared/components/table/renderers/bar-chart-renderer/bar-chart-renderer.component";
import { NumberFormatWithDotRendererComponent } from "@valg-shared/components/table/renderers/number-format-with-dot-renderer/number-format-with-dot-renderer.component";
import { ColumnMetadata } from "@valg-shared/components/table/table/column-metadata";
import { TableDataItem } from "@valg-shared/components/table/table/table.component";
import { WithPropsOfType } from "@valg-shared/forms";

export interface ReferendumStatus extends TableDataItem {
  option: string;
  votes?: number | null;
  percentage?: number | null;
}

export const ReferendumStatusColumnDef: WithPropsOfType<ReferendumStatus, ColumnMetadata> = {
  id: {
    title: "",
    disable: true
  },
  option: {
    title: 'election_overview.fa_election.table.header.option'
  },
  votes: {
    title: 'election_overview.fa_election.table.header.votes',
    defaultValue: '-',
    presentationComponent: NumberFormatWithDotRendererComponent
  },
  percentage: {
      title: 'election_overview.fa_election.table.header.percentage',
      presentationComponent: BarChartRendererComponent,
      defaultValue: '-',
      rendererOptions: new Map().set('textPath', 'name'),
  }
};
